<script setup lang="ts">

const icons = [
  'newspaper',
  'bitcoin',
  'crypto',
  'chart-column-increasing',
  'exchange-rates',
  'sidebar-rates',
  'chart-candlestick',
  'forex',
  'scale',
  'lawyer',
  'arrow-left-right',
  'money-transfers',
  'calculator',
  'tax-service',
  'handshake',
  'business',
  'scroll-text',
  'legislation',
  'kyrgyzcha',
  'info',
  'currency',
  'consumer',
  'replenished',
  'termination',
  'other',
  'investments',
  'employer',
  'capitalization',
  'monthly_income',
  'islamic',
  'kids',
  'pensionary',
  'best',
  'car-front',
  'autos',
  'auto',
  'building',
  'mortgage',
  'tractor',
  'agrocredit',
  'calendar-1',
  'leasing',
  'wallet-cards',
  'overdraft',
  'calendar-clock',
  'installment',
  'vault',
  'bank-guarantee',
  'leafy-green',
  'green',
  'banknote-x',
  'no-profit',
  'hand-helping',
  'no-guarantee',
  'credit-card',
  'shield-check',
  'message-square',
  'refresh-ccw',
  'plane',
  'aviation',
  'syringe',
  'medical',
  'octagon-alert',
  'danger',
  'truck',
  'transport',
  'person-standing',
  'passengers',
  'property',
  'fence',
  'user-pen',
  'professional',
  'pyramid',
  'tourism',
  'plane-takeoff',
  'outboard',
  'shield-user',
  'accidents',
  'car',
  'osago',
  'mfk',
  'mkk',
  'mka',
  'KGS',
  'currency_1',
  'USD',
  'currency_2',
  'EUR',
  'curency_3',
  'RUB',
  'currency_4',
  'remote',
  'laptop-minimal-check',
  'house',
  'realestate_support',
  'headset',
  'haze',
  'google-play',
  'app-store'
]
</script>

<template>
  <Container class="py-12">
    <div class="rounded-lg bg-white p-8">
      <Content>
        <h1>Lorem ipsum dolor sit amet.</h1>
        <h2>Lorem ipsum dolor sit amet, consectetur adipisicing.</h2>
        <h3>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</h3>
        <h4>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</h4>
        <h5>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</h5>
        <h6>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</h6>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Cumque ipsa maxime obcaecati
          officia officiis saepe sit ullam. Cumque ipsa maxime obcaecati officia officiis saepe sit
          ullam. Accusantium corporis culpa distinctio earum illum ipsum magni qui velit vitae,
          voluptatem voluptatibus!
        </p>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Cumque ipsa maxime obcaecati
          officia officiis saepe sit ullam. Accusantium corporis culpa distinctio earum illum ipsum
          magni qui velit vitae, voluptatem voluptatibus!
        </p>
        <ul>
          <li>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</li>
          <li>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</li>
          <li>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</li>
          <li>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</li>
          <li>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</li>
        </ul>
        <p>
          Lorem ipsum dolor sit amet, <a href="/news">consectetur adipisicing</a> elit. A aliquid,
          aut deserunt eos esse eveniet excepturi, exercitationem <a href="/">fuga</a>, id iste
          nihil odit quaerat quas quasi sequi similique voluptas voluptate
          <a href="https://valuta.kg/">voluptatibus</a>.
        </p>
        <ol>
          <li>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</li>
          <li>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit.
            <ul>
              <li>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</li>
              <li>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</li>
              <li>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</li>
            </ul>
          </li>
          <li>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</li>
          <li>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</li>
        </ol>
        <hr />
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Cumque ipsa maxime obcaecati
          officia officiis saepe sit ullam. Accusantium corporis culpa distinctio earum illum ipsum
          magni qui velit vitae, voluptatem voluptatibus!
        </p>
        <table>
          <thead>
            <tr>
              <th>Col 1</th>
              <th>Col 2</th>
              <th>Col 3</th>
              <th>Col 4</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Row 1</td>
              <td>Row 1</td>
              <td>Row 1</td>
              <td>Row 1</td>
            </tr>
            <tr>
              <td>Row 2</td>
              <td>Row 2</td>
              <td>Row 2</td>
              <td>Row 2</td>
            </tr>
            <tr>
              <td>Row 3</td>
              <td>Row 3</td>
              <td>Row 3</td>
              <td>Row 3</td>
            </tr>
            <tr>
              <td>Row 4</td>
              <td>Row 4</td>
              <td>Row 4</td>
              <td>Row 4</td>
            </tr>
          </tbody>
        </table>
      </Content>
    </div>

    <div class="space-y-3 rounded-lg bg-white p-8">
      <h1>Список всех иконок</h1>
      <div class="grid grid-cols-3 gap-4">
        <div v-for="icon in icons" :key="icon" class="text-center">
          <div class="flex gap-2">
            <div class="icon"><UiIcon :name="icon" /></div>
            <p>{{ icon }}</p>
          </div>
        </div>
      </div>
    </div>
  </Container>
</template>
